<template>
    <v-flex class="communities" v-if="isYpoCommunitiesVisible || isCurrentUser">
        <v-flex tag="h2">{{memberProfileConstants.MY_YPO_COMMUNITIES}}
            <!-- TODO: Hiding the Popup Icon, will be done later 
            <i class="fas fa-external-link-alt"></i> -->
        </v-flex>
        <v-layout row wrap class="communities__block" v-if="isChpatersSectionVisible">
            <v-flex v-if="networkChpaterLength" :class="networkRegionLength ? 'xs6' : 'xs12'">
                <v-flex tag="h4">{{memberProfileConstants.CHAPTERS}}</v-flex>
                <v-flex v-for="(chapter,index) in networkChapters" :key="index">
                    <v-flex>
                        <a href="" @click.prevent="communityRedirect(chapter)" :data-qe-id="'myCommunitiesChapter_hyperLink'+index">{{chapter.name}} <i v-if="chapter.isPrimary" class="fas fa-check goldcheckmark"></i></a>
                    </v-flex>
                </v-flex>
            </v-flex>
            <v-flex v-if="networkRegionLength" :class="networkChpaterLength ? 'xs6' : 'xs12'">
                <v-flex tag="h4">{{memberProfileConstants.REGIONS}}</v-flex>
                <v-flex v-for="(region,index) in sortNetworkRegionsByAsc" :key="index">
                    <v-flex><a href="" @click.prevent="communityRedirect(region)" :data-qe-id="'myCommunitiesRegions_hyperLink'+index">{{region.name}}</a></v-flex>
                </v-flex>
            </v-flex>
        </v-layout>
        <v-layout
            row
            wrap
            mt-3
            class="communities__block"
            v-if="isNetworkSectionVisible || isCurrentUser">
            <status-overlay :action="loadGetNetworksAction" content-height="60px">
            </status-overlay>
            <v-flex xs12>
                <v-flex tag="h4">{{memberProfileConstants.NETWORKS}} {{displayCount(networkCount)}}
                    <v-flex
                        tag="em"
                        v-if="isSeeAllVisible"
                        @click="gotoSeeAll()"
                        :data-qe-id="'myCommunitiesNetworks_seeAll'">{{seeAll}}</v-flex>
                </v-flex>
                <v-flex>
                    <v-flex v-if="!isNetworkSectionVisible && isCurrentUser"> 
                        <v-flex tag="em" ml-0 data-qe-id="open_member-networks" @click="openCommunityDirectory(memberProfileConstants.NETWORKS)"> {{memberProfileConstants.DEFAULT_EDIT_TEXT.NETWORKS_LINK}}</v-flex>
                        <span> {{memberProfileConstants.DEFAULT_EDIT_TEXT.NETWORKS_TEXT}} </span>
                    </v-flex>
                </v-flex>
            </v-flex> 
            <v-layout row wrap>
                <v-flex xs6 sm3 class="communities__block__networks" v-if="Business.length > 0">
                    <v-flex tag="h4">{{memberProfileConstants.BUSINESS}}</v-flex>
                    <v-flex v-if="!enabled">
                        <v-flex v-for="(business,index) in Business.slice(0,2)"
                                @click.prevent="networkRedirect(business)"
                                :key="index" class="network_v-flex">
                            <img :data-qe-id="'myCommunitiesBusiness_img'+index" class='communities__block__clickble' :src="business.iconUrl"/>
                            <a :data-qe-id="'myCommunitiesBusiness_hyperLink'+index" class='communities__block__clickble'>{{business.name}}</a>
                        </v-flex>
                    </v-flex>
                    <v-flex v-if="enabled">
                        <v-flex v-for="(business,index) in Business" :key="index" class="network_v-flex"
                                @click.prevent="networkRedirect(business)">
                            <img :data-qe-id="'myCommunitiesBusiness_img'+index" class='communities__block__clickble' :src="business.iconUrl"/>
                            <a :data-qe-id="'myCommunitiesBusiness_hyperLink'+index" class='communities__block__clickble'>{{business.name}}</a>
                        </v-flex>
                    </v-flex>
                </v-flex>
                <v-flex xs6 sm3 class="communities__block__networks" v-if="Family.length > 0">
                    <v-flex tag="h4">{{memberProfileConstants.FAMILY}}</v-flex>
                    <v-flex v-if="!enabled">
                        <v-flex v-for="(family,index) in Family.slice(0,2)" :key="index" class="network_v-flex" @click.prevent="networkRedirect(family)">
                            <img :data-qe-id="'myCommunitiesFamily_img'+index" class='communities__block__clickble' :src="family.iconUrl"/>
                            <a :data-qe-id="'myCommunitiesFamily_hyperLink'+index" class='communities__block__clickble'>{{family.name}}</a>
                        </v-flex>
                    </v-flex>
                    <v-flex v-if="enabled">
                        <v-flex v-for="(family,index) in Family" :key="index" class="network_v-flex" @click.prevent="networkRedirect(family)">
                            <img :data-qe-id="'myCommunitiesFamily_img'+index" class='communities__block__clickble' :src="family.iconUrl"/>
                            <a :data-qe-id="'myCommunitiesFamily_hyperLink'+index" class='communities__block__clickble'>{{family.name}}</a>
                        </v-flex>
                    </v-flex>
                </v-flex>
                <v-flex xs6 sm3 class="communities__block__networks" v-if="Personal.length > 0">
                    <v-flex tag="h4">{{memberProfileConstants.PERSONAL}}</v-flex>
                    <v-flex v-if="!enabled">
                        <v-flex v-for="(personal,index) in Personal.slice(0,2)" :key="index" class="network_v-flex" @click.prevent="networkRedirect(personal)">
                            <img :data-qe-id="'myCommunitiesPersonal_img'+index" class='communities__block__clickble' :src="personal.iconUrl"/>
                            <a :data-qe-id="'myCommunitiesPersonal_hyperLink'+index" class='communities__block__clickble'>{{personal.name}}</a>
                        </v-flex>
                    </v-flex>
                    <v-flex v-if="enabled">
                        <v-flex v-for="(personal,index) in Personal" :key="index" class="network_v-flex" @click.prevent="networkRedirect(personal)">
                            <img :data-qe-id="'myCommunitiesPersonal_img'+index" class='communities__block__clickble' :src="personal.iconUrl"/>
                            <a :data-qe-id="'myCommunitiesPersonal_hyperLink'+index" class='communities__block__clickble'>{{personal.name}}</a>
                        </v-flex>
                    </v-flex>
                </v-flex>
                <v-flex xs6 sm3 class="communities__block__networks" v-if="Social.length > 0">
                    <v-flex tag="h4">{{memberProfileConstants.IMPACT}}</v-flex>
                    <v-flex v-if="!enabled">
                        <v-flex v-for="(social,index) in Social.slice(0,2)" :key="index" class="network_v-flex" @click.prevent="networkRedirect(social)">
                            <img :data-qe-id="'myCommunitiesSocial_img'+index" class='communities__block__clickble' :src="social.iconUrl"/>
                            <a :data-qe-id="'myCommunitiesSocial_hyperLink'+index" class='communities__block__clickble'>{{social.name}}</a>
                        </v-flex>
                    </v-flex>
                    <v-flex v-if="enabled">
                        <v-flex v-for="(social,index) in Social" :key="index" class="network_v-flex" @click.prevent="networkRedirect(social)">
                            <img :data-qe-id="'myCommunitiesSocial_img'+index" class='communities__block__clickble' :src="social.iconUrl"/>
                            <a :data-qe-id="'myCommunitiesSocial_hyperLink'+index" class='communities__block__clickble'>{{social.name}}</a>
                        </v-flex>
                    </v-flex>
                </v-flex>
            </v-layout>
        </v-layout>
        <v-layout
            row
            wrap
            mt-3
            class="communities__block" v-if="isGroupSectionVisible || isCurrentUser">
            <v-flex tag="h4" xs12>{{memberProfileConstants.GROUPS}} {{displayCount(communitiesGroup.length)}}
                <v-flex
                    tag="em"
                    v-if="isSeeAllGroups"
                    @click="gotoSeeAllGroups()"
                    :data-qe-id="'myCommunitiesGroups_seeAll'">{{seeAllGroups}}</v-flex>
            </v-flex>
            <v-flex v-if="!isGroupSectionVisible && isCurrentUser"> 
                <v-flex tag="em" ml-0  data-qe-id="open_member-groups" @click="openCommunityDirectory(memberProfileConstants.GROUPS)"> {{memberProfileConstants.DEFAULT_EDIT_TEXT.GROUPS_LINK}}</v-flex>
                <span> {{memberProfileConstants.DEFAULT_EDIT_TEXT.GROUPS_TEXT}} </span>
            </v-flex>
            <v-layout row wrap v-if="!expanded">
                <v-flex xs12 sm4  v-for="(row, idx1) in groupSeeLess" :key="idx1">
                    <v-flex v-for="(col, idx2) in row" :key="idx2">
                        <v-flex>
                            <a :data-qe-id="`groups_title_${idx2}`" href=""
                               @click.prevent="communityRedirect(groupSeeLess[idx1][idx2])"
                               :title="groupSeeLess[idx1][idx2] ? groupSeeLess[idx1][idx2].name : null">
                                {{groupSeeLess[idx1][idx2] ? groupSeeLess[idx1][idx2].name : null}}
                            </a>
                        </v-flex>
                    </v-flex>
                </v-flex>
            </v-layout>
            <v-layout row wrap v-if="expanded">
                <v-flex xs12 sm4  v-for="(row, idx1) in groups" :key="idx1">
                    <v-flex v-for="(col, idx2) in row" :key="idx2">
                        <v-flex>
                            <a :data-qe-id="`groups_title_${idx2}`" :href="normalizeUrl(groups[idx1][idx2].navigationUrl)" target="_self" :title="groups[idx1][idx2] ? groups[idx1][idx2].name : null">
                                {{groups[idx1][idx2] ? groups[idx1][idx2].name : null}}
                            </a>
                        </v-flex>
                    </v-flex>
                </v-flex>
            </v-layout>
        </v-layout>
        <v-layout
            row
            wrap
            mt-3
            class="communities__block" v-if="isCommunitySectionVisible">

            <v-flex tag="h4" xs12>
                {{memberProfileConstants.COMMUNITIES}} {{displayCount(communities.length)}}
                <v-flex
                    tag="em"
                    v-if="isSeeAllCommunities"
                    @click="expandedCommunities = !expandedCommunities"
                    :data-qe-id="'myCommunities_seeAll'">
                    {{seeAllCommunities}}
                </v-flex>
            </v-flex>
            <v-layout row wrap v-if="!expandedCommunities">
                <v-flex xs12 sm4 v-for="(row, idx1) in communitiesSeeLess" :key="idx1">
                    <v-flex v-for="(col, idx2) in row" :key="idx2">
                        <v-flex>
                        <a
                            :data-qe-id="`communities_title_${idx2}`"
                            href=""
                            @click.prevent="communitiesRedirect(communitiesSeeLess[idx1][idx2])"
                            :title="communitiesSeeLess[idx1][idx2].name">
                            {{communitiesSeeLess[idx1][idx2].name}}
                        </a>
                        </v-flex>
                    </v-flex>
                </v-flex>
            </v-layout>
            <v-layout row wrap v-if="expandedCommunities">
                <v-flex xs12 sm4 v-for="(row, idx1) in communitiesGrid" :key="idx1">
                    <v-flex v-for="(col, idx2) in row" :key="idx2">
                        <v-flex>
                            <a
                            :data-qe-id="`communities_title_${idx2}`"
                            href=""
                            @click.prevent="communitiesRedirect(communitiesGrid[idx1][idx2])"
                            :title="communitiesGrid[idx1][idx2].name">
                            {{communitiesGrid[idx1][idx2].name}}
                            </a>
                        </v-flex>
                    </v-flex>
                </v-flex>
            </v-layout>
        </v-layout>

    </v-flex>
</template>

<script>
    import { mapActions, mapGetters, mapState } from "vuex";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { memberProfileConstants, navigateToCommunityDirectory } from "./memberProfile.constants.js";
    import orderBy from "lodash/orderBy";
    import { normalizeUrl } from '@/common/utils/utils';
    import StatusOverlay from '../StatusOverlay/StatusOverlay';
    import { getHbRedirectByCommunityId } from "@/common/utils/hivebriteUtils";

    export default {
        name: "YpoCommunities",
        data: () => ({
            memberProfileConstants,
            enabled: false,
            expanded: false,
            Business: [],
            Family: [],
            Personal: [],
            Social: [],
            groups: [],
            groupSeeLess: [],
            expandedCommunities: false,
            communitiesGrid: [],
            communitiesSeeLess: [],
        }),
        components: {
            StatusOverlay,
        },
        props: {
            memberId: {
                type: String,
                required: true,
            },
        },
        created() {
            this.getNetworks(this.memberId);
            this.getNetworkChapters(this.memberId);
            this.getNetworkRegions(this.memberId);
            this.getCommunitiesGroups(this.memberId);
            this.getCommunities(this.memberId);
        },
        methods: {
            ...mapActions({
                getNetworkChapters: `memberProfile/${storeAction.getNetworkChapters}`,
                getNetworkRegions: `memberProfile/${storeAction.getNetworkRegions}`,
                getNetworks: `memberProfile/${storeAction.getNetworks}`,
                getCommunitiesGroups: `memberProfile/${storeAction.getCommunitiesGroups}`,
                getCommunities: `memberProfile/${storeAction.getCommunities}`,
            }),
            gotoSeeAll() {
                this.enabled = !this.enabled;
            },
            communityRedirect(communityItem) {
              const hbRedirectCommunity = getHbRedirectByCommunityId(this.connectPlusRedirects, communityItem.id);
              if (hbRedirectCommunity) {
                window.open(hbRedirectCommunity.redirectUrl, '_self');
              } else {
                this.$router.push({
                  path: `/${communityItem.type.toLowerCase()}/${communityItem.id}`,
                  query: { name: communityItem.name },
                });
              }
            },
            networkRedirect(networkItem) {
              const hbRedirectCommunity = getHbRedirectByCommunityId(this.connectPlusRedirects, networkItem.id);
              if (hbRedirectCommunity) {
                window.open(hbRedirectCommunity.redirectUrl, '_self');
              } else {
                this.$router.push({
                  path: `/${networkItem.recordTypeName.toLowerCase()}/${networkItem.id}`,
                  query: { name: networkItem.name },
                });
              }
            },
            communitiesRedirect(communities) {
              const hbRedirectCommunity = getHbRedirectByCommunityId(this.connectPlusRedirects, communities.id);
              if (hbRedirectCommunity) {
                window.open(hbRedirectCommunity.navigationUrl, '_self');
              } else {
                this.$router.push({
                  path: `/communities/${communities.id}`,
                  query: { name: communities.name },
                });
              }
            },
            redirectToNetworkPage: (url) => {
                if (url && !url.includes('http')) url = `http://${url}`;
                window.open(url, '_parent');
            },
            truncateNetworkName(data) {
                const dots = "...";
                if (data) {
                    return data.length >
                        memberProfileConstants.MYCOMMUNITIES_NETWORK_NAME_MAX_TEXT_LENGTH ?
                        data.substring(0, memberProfileConstants.MYCOMMUNITIES_NETWORK_NAME_MAX_TEXT_LENGTH) + dots :
                        data;
                }
            },
            gotoSeeAllGroups() {
                this.expanded = !this.expanded;
            },
            gotoSeeAllCommunities() {
                this.expanded = !this.expanded;
            },
            normalizeUrl(url) {
                return normalizeUrl(url);
            },
            openCommunityDirectory(type) {
                this.$router.push(navigateToCommunityDirectory(type)); 
            },
            displayCount(value) {
                if (value > 0) {
                    return `(${value})`;
                }
                return '';
            },
        },
        computed: {
            ...mapGetters({
                networkChapters: `memberProfile/${storeGetters.networkChapters}`,
                networkRegions: `memberProfile/${storeGetters.networkRegions}`,
                networks: `memberProfile/${storeGetters.networks}`,
                isYpoCommunitiesVisible: `memberProfile/${storeGetters.isYpoCommunitiesVisible}`,
                currentUserId: `memberProfile/${storeGetters.currentUserId}`,
                communitiesGroup: `memberProfile/${storeGetters.communitiesGroup}`,
                chapterAdminEditable: `memberProfile/${storeGetters.chapterAdmin}`,
                connectPlusRedirects: `connectPlus/${storeGetters.connectPlusRedirects}`,
                communities: `memberProfile/${storeGetters.communities}`,
            }),
            ...mapState("actionState", ["actions"]),
            networkChpaterLength() {
                return (this.networkChapters && this.networkChapters.length > 0);
            },
            networkRegionLength() {
                return (this.networkRegions && this.networkRegions.length > 0);
            },
            communitiesLength() {
                return (this.communities && this.communities.length > 0);
            },
            isChpatersSectionVisible() {
                return (this.networkChapters && this.networkChapters.length > 0) || (this.networkRegions && this.networkRegions.length > 0);
            },
            isNetworkSectionVisible() {
                return this.Business.length > 0 || this.Family.length > 0 || this.Personal.length > 0 || this.Social.length > 0;
            },
            isSeeAllVisible() {
                return this.Business.length > 2 || this.Family.length > 2 || this.Personal.length > 2 || this.Social.length > 2;
            },
            seeAll() {
                return this.enabled ?
                    memberProfileConstants.SEE_LESS :
                    memberProfileConstants.SEE_ALL;
            },
            seeAllGroups() {
                return this.expanded ?
                    memberProfileConstants.SEE_LESS :
                    memberProfileConstants.SEE_ALL;
            },
            seeAllCommunities() {
                return this.expandedCommunities
                ? memberProfileConstants.SEE_LESS
                : memberProfileConstants.SEE_ALL;
            },
            sortNetworkRegionsByAsc() {
                return orderBy(this.networkRegions, "name", "asc");
            },
            networkCount() {
                return this.Business.length + this.Family.length + this.Personal.length + this.Social.length;
            },
            isCurrentUser() {
                return this.memberId === this.currentUserId || this.chapterAdminEditable;
            },
            isGroupSectionVisible() {
                return this.communitiesGroup && this.communitiesGroup.length > 0;
            },
            isCommunitySectionVisible() {
                return this.communities && this.communities.length > 0;
            },
            isSeeAllGroups() {
                return this.communitiesGroup.length > 9;
            },
            isSeeAllCommunities() {
                return this.communities.length > 9;
            },
            loadGetNetworksAction() {
                return this.actions[storeAction.getNetworks];
            }, 
        },
        watch: {
            networks(networkData) {
                if (networkData && networkData.length > 0) {
                    Object.values(networkData).forEach((x) => {
                        if (x.type === memberProfileConstants.BUSINESS) {
                            x.name = this.truncateNetworkName(x.name);
                            this.Business.push(x);
                        } else if (x.type === memberProfileConstants.FAMILY) {
                            x.name = this.truncateNetworkName(x.name);
                            this.Family.push(x);
                        } else if (x.type === memberProfileConstants.PERSONAL) {
                            x.name = this.truncateNetworkName(x.name);
                            this.Personal.push(x);
                        } else if (x.type === memberProfileConstants.IMPACT) {
                            x.name = this.truncateNetworkName(x.name);
                            this.Social.push(x);
                        }
                    });
                }
            },
            communitiesGroup(val) {
                this.groups = [];
                this.groupSeeLess = [];
                if (val.length > 0) {
                    let grouplength = val.length;
                    const colLimit = this.memberProfileConstants.COLUMN_LIMIT;
                    for (let i = 0; i < grouplength; i += 1) {
                        this.groups[i] = [];
                    }
                    const rowLimit = (grouplength % colLimit) === 0 ? Math.floor(grouplength / colLimit) : Math.floor(grouplength / colLimit) + 1;
                    val.forEach((ci, i) => {
                        const colNum = Math.floor(i / rowLimit);
                        const rowNum = i % rowLimit;
                        this.groups[colNum][rowNum] = ci;
                    });
                    if (grouplength > 9) {
                        grouplength = 9;
                    }
                    for (let i = 0; i < grouplength; i += 1) {
                        this.groupSeeLess[i] = [];
                    }
                    const rowLimit1 = (grouplength % colLimit) === 0 ? Math.floor(grouplength / colLimit) : Math.floor(grouplength / colLimit) + 1;
                    val.slice(0, 9).forEach((ci, i) => {
                        const colNum = Math.floor(i / rowLimit1);
                        const rowNum = i % rowLimit1;
                        this.groupSeeLess[colNum][rowNum] = ci;
                    });
                }
                if (val.length <= 9) {
                    this.expanded = false;
                }
            },
            communities(val) {
                this.communitiesGrid = [];
                this.communitiesSeeLess = [];

                if (val.length > 0) {
                const colLimit = this.memberProfileConstants.COLUMN_LIMIT;
                let commLength = val.length;

                // Full grid
                for (let i = 0; i < commLength; i++) {
                    this.communitiesGrid[i] = [];
                }
                const rowLimit = (commLength % colLimit) === 0
                    ? Math.floor(commLength / colLimit)
                    : Math.floor(commLength / colLimit) + 1;

                val.forEach((ci, i) => {
                    const colNum = Math.floor(i / rowLimit);
                    const rowNum = i % rowLimit;
                    this.communitiesGrid[colNum][rowNum] = ci;
                });

                // Limited view (up to 9)
                const seeLessLength = Math.min(9, commLength);
                for (let i = 0; i < seeLessLength; i++) {
                    this.communitiesSeeLess[i] = [];
                }
                const rowLimit1 = (seeLessLength % colLimit) === 0
                    ? Math.floor(seeLessLength / colLimit)
                    : Math.floor(seeLessLength / colLimit) + 1;

                val.slice(0, 9).forEach((ci, i) => {
                    const colNum = Math.floor(i / rowLimit1);
                    const rowNum = i % rowLimit1;
                    this.communitiesSeeLess[colNum][rowNum] = ci;
                });
                }

                if (val.length <= 9) {
                this.expandedCommunities = false;
                }
            }
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .communities {
        position: relative;
        background: $ypo_blue;
        box-shadow: 0 0 3px 0 rgba($black, 0.5);
        border-radius: 4px;
        padding: 20px;

        h2 {
            color: $white;
            padding: 0 0px 10px 5px;
            font-family: Raleway;
            font-weight: 500;

            i {
                color: $ypo-dark-background-gray;
                font-size: 14px;
                position: relative;
                left: 5px;
                margin-right: 40px;
                cursor: pointer;
            }
        }

        h4 {
            color: $ypo_blue;
            font-size: 16px;
            font-weight: bold;
            line-height: 26px;
            border-bottom: 1px solid $ypo-open-blue-gray;
            margin-bottom: 10px;
            padding-bottom: 5px;
        }

        &__block {
            background: $white;
            box-shadow: 0 0 3px 0 rgba($black, 0.5);
            border-radius: 4px;
            padding: 15px;
            &__clickble {
                cursor: pointer;
            }

            em {
                color: $ypo-cta;
                font-family: "Noto Sans";
                font-size: 14px;
                line-height: 24px;
                font-style: normal;
                margin-left: 10px;
                cursor: pointer;
                font-weight: 500;
            }

            a {
                text-decoration: none;
                margin-bottom: 15px;
                display: block;
                color: $ypo-cta;
                font-size: 14px;
                padding-right: 70px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                    @include breakpoint(xs) {
                        position: relative;
                    }
            }

            &__networks {
                text-align: center;

                h4 {
                    border: none;
                    margin-bottom: 0;
                }

                img {
                    max-width: 80px;
                    border-radius: 50%;
                    text-align: center;
                    margin: 10px 0;
                }

                a {
                    display: block;
                    color: $ypo-cta;
                    font-size: 12px;
                    line-height: 16px;
                    text-align: center;
                    padding: 0 10px;
                }
            }
        }

        .overlay {
            top: 200px;
            left: 20px;
            right: 20px;
        }
    }

    .goldcheckmark {
        color: $ypo-gold;
        margin-left: 5px;
        @include breakpoint(xs) {
            position: absolute;
            right: 45px;
            top: 5px;
        }
    }

    .network_v-flex {
        min-height: 153px;
        word-wrap: break-word;

    }
    @media (max-width: 1023px) {
        .communities {
            margin-bottom: 15px;
        }
    }
    @media (max-width: 767px) {
        .communities {
            padding: 15px 10px 10px 10px;
        }
    }
</style>
